import { Box, Typography, TypographyProps } from '@mui/material';
import React, { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  titleAdditionalSlot?: ReactNode;
  extras?: ReactNode;
  headerVariant?: TypographyProps['variant'];
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  titleAdditionalSlot,
  extras,
  headerVariant = 'h4',
}) => {
  return (
    <Box sx={{ py: 4 }}>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
        }}>
        {title ? (
          <>
            <Typography color="textPrimary" variant={headerVariant}>
              {title}
            </Typography>
            {titleAdditionalSlot}
            <Box sx={{ flexGrow: 1 }} />
          </>
        ) : null}
        {extras}
      </Box>
    </Box>
  );
};
